import { render, staticRenderFns } from "./PracticeOrderResult.vue?vue&type=template&id=0b031d88&scoped=true"
import script from "./PracticeOrderResult.vue?vue&type=script&lang=js"
export * from "./PracticeOrderResult.vue?vue&type=script&lang=js"
import style0 from "./PracticeOrderResult.vue?vue&type=style&index=0&id=0b031d88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b031d88",
  null
  
)

export default component.exports